import React, { useState, useEffect } from 'react';

const Popup = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        // Mostra il popup espanso la prima volta dopo 3 secondi
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (isVisible) {
            setIsExpanded(true);
        }
    }, [isVisible]);

    const handleClose = () => {
        setIsExpanded(false);
    };

    const handleIconClick = () => {
        setIsExpanded(true);
    };

    if (!isVisible) return null;

    if (!isExpanded) {
        return (
            <div className="ceremony-popup-icon" onClick={handleIconClick}>
                <div className="popup-icon-small">✨</div>
            </div>
        );
    }

    return (
        <div className="ceremony-popup">
            <div className="popup-content-small">
                <button className="popup-close" onClick={handleClose}>
                    ×
                </button>
                <div className="popup-icon">✨</div>
                <h3 className='bold'>Importante aggiornamento</h3>
                <h3>L'orario della cerimonia è cambiato: inizierà alle</h3>
                <div className="ceremony-time">15:00</div>
            </div>
        </div>
    );
};

export default Popup; 